/* =============================================
   COOKIE CONSENT — GDPR / EU
   ============================================= */
(function () {
    'use strict';
    return; // DISABLED — using Shopify Customer Privacy banner

    var COOKIE_KEY = 'iqone_cookie_consent';

    function getConsent() {
        try { return localStorage.getItem(COOKIE_KEY); } catch(e) { return null; }
    }

    function setConsent(value) {
        try { localStorage.setItem(COOKIE_KEY, value); } catch(e) {}
    }

    function hideBanner() {
        var banner = document.getElementById('cookie-banner');
        if (banner) {
            banner.classList.remove('visible');
            setTimeout(function() { banner.style.display = 'none'; }, 500);
        }
    }

    function init() {
        if (getConsent()) return; // Already consented or rejected

        var banner = document.getElementById('cookie-banner');
        if (!banner) return;

        // Show banner with slight delay
        setTimeout(function() {
            banner.style.display = '';
            requestAnimationFrame(function() {
                banner.classList.add('visible');
            });
        }, 1200);

        var acceptBtn = document.getElementById('cookie-accept');
        var rejectBtn = document.getElementById('cookie-reject');

        if (acceptBtn) {
            acceptBtn.addEventListener('click', function() {
                setConsent('accepted');
                hideBanner();
            });
        }

        if (rejectBtn) {
            rejectBtn.addEventListener('click', function() {
                setConsent('rejected');
                hideBanner();
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
